import React from "react";
import {dayMonthYearAtTime} from "../utils/dates";
import Objects from "../utils/Objects";
import DateFilter from "./component/DateFilter";

class PolicyEventGrid {

  title = "Lista de Eventos";

  columns = [
    {
      Header: "Nome",
      accessor: "beacon.name"
    },
    {
      Header: "Politica",
      accessor: "policy.name"
    },
    {
      Header: "Estado",
      accessor: "newState"
    },
    {
      Header: "Data",
      accessor: "timestamp",
      Cell: row => dayMonthYearAtTime(row.original.timestamp)
    }
  ];

  customHeader = (props, state, onChange) => {
    const customFilter = {};
    return <DateFilter {...props}
                       onChangeDateBegin={value => {
                         customFilter.dateBegin = value;
                         this.dateBegin = customFilter.dateBegin;
                         onChange(customFilter);
                       }}
                       onChangeDateEnd={value => {
                         customFilter.dateEnd = value;
                         this.dateEnd = customFilter.dateEnd;
                         onChange(customFilter);
                       }}/>
  };
  endpoint = (props, state) => {
    const {customFilter = {}, metadata} = state;
    this.dateEnd = customFilter.dateEnd || metadata.dateBegin;
    this.dateBegin = customFilter.dateBegin || metadata.dateBegin;

    let filter = "integration/v1/policy-events?";

    if (Objects.nonEmptyOrBlank(customFilter.dateBegin)) {
      if (Objects.nonEmptyOrBlank(customFilter.dateEnd)) {
        filter += '&dateEnd=' + new Date(customFilter.dateEnd).toISOString();
        filter += '&dateBegin=' + new Date(customFilter.dateBegin).toISOString();
      }
    }

    return filter;
  }
}

export default PolicyEventGrid;



// WEBPACK FOOTER //
// ./src/bluzone/PolicyEventGrid.js